(function (window) {
  //récupération des éléments dans des variable
  var openCtrl = document.getElementById('btn-search'),
    closeCtrl = document.getElementById('btn-search-close'),
    searchContainer = document.querySelector('.search-container');

  //ouvertuire de la fenetre
  function openSearch() {
    searchContainer.classList.add('search--open');
  }

  //fermeture de la fenetre
  function closeSearch() {
    searchContainer.classList.remove('search--open');
  }

  //ecoute des manipulation utilisateur
  function initEvents() {
    openCtrl.addEventListener('click', openSearch);
    closeCtrl.addEventListener('click', closeSearch);
    document.addEventListener('keyup', function (ev) {
      // Si l'utilisateur appuie sur echap-->ferme la fenetre
      if (ev.keyCode === 27) {
        closeSearch();
      }
    });
  }
  function init() {
    initEvents();
  }
  init();
})(window);

// //script pour mobile 
// (function(window) {

//   //récupération des éléments dans des variable
//     var openCtrl = document.getElementById('btn-search--mobile'),
//         closeCtrl = document.getElementById('btn-search-close--mobile'),
//         searchContainer = document.querySelector('.search-container--mobile');

//   //ouvertuire de la fenetre
//     function openSearch() {
//         searchContainer.classList.add('search--open');
//     }

//   //fermeture de la fenetre
//     function closeSearch() {
//         searchContainer.classList.remove('search--open');
//     }

//   //ecoute des manipulation utilisateur
//     function initEvents() {
//         openCtrl.addEventListener('click', openSearch);
//         closeCtrl.addEventListener('click', closeSearch);
//         document.addEventListener('keyup', function(ev) {
//             // Si l'utilisateur appuie sur echap-->ferme la fenetre
//             if( ev.keyCode === 27 ) {
//                 closeSearch();
//             }
//         });
//     }

//     function init() {
//         initEvents();	
//     }

//     init();

// })(window);